import { Checkbox, Tooltip } from "@findemdev/maui";
import { ICompanyList } from "../../../types/common";
import { useShareWithOrg } from "../../../hooks/useShareWithOrg";
import ShareListModal from "../../Builder/ShareListModal";
import UnshareListModal from "../../Builder/UnshareListModal";
import useIsCompanyListOwner from "../../../hooks/useIsCompanyListOwner";

interface IShareWithOrgToggleProps {
  companyList: ICompanyList;
}

const ShareWithOrgToggle = ({ companyList }: IShareWithOrgToggleProps) => {
  const isOwner = useIsCompanyListOwner(companyList);
  const {
    isSharedWithOrg,
    modalOpen,
    unshareModalOpen,
    isLoading,
    closeShareModal,
    closeUnshareModal,
    handleToggle,
    handleShareAndContinue,
    handleStopSharing,
  } = useShareWithOrg(companyList);

  return (
    <>
      <Tooltip title={!isOwner ? "Only the owner can unshare this list" : ""}>
        <Checkbox onChange={handleToggle} checked={isSharedWithOrg} disabled={!isOwner} />
      </Tooltip>
      <ShareListModal
        open={modalOpen}
        isLoading={isLoading}
        onShareAndContinue={handleShareAndContinue}
        onClose={closeShareModal}
      />
      <UnshareListModal
        open={unshareModalOpen}
        isLoading={isLoading}
        onStopSharing={handleStopSharing}
        onClose={closeUnshareModal}
      />
    </>
  );
};

export default ShareWithOrgToggle;
